import * as moment from "moment";
import Excel from "exceljs";
import FileSaver from "file-saver";
import mushroom from "cem-primary-api";
import { Filter } from "mushroomjs";
import LanguageService from "@/service/LanguageService";
import DOMPurify from "dompurify";
import Swal from "sweetalert2";
let MethodService = {};

// -------------------MethodService-------------------------
function escapeRegex(string) {
  return string.toString().replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&");
}
MethodService.extractBaseUrl = (url) => {
  if (!url) return "";
  const idx = url.indexOf("/entry.html");
  return idx > -1 ? url.substring(0, idx) : url;
}
MethodService.formatDateYYYYMMDD = (value) => {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};
MethodService.purifyUrl = (url) => {
  if (typeof url !== "string") return "#";
  const regex = /^(\w{1,255}):/g;
  const sanitizedUrl = DOMPurify.sanitize(url).replace(/&amp;/g, "&");
  const allowedStrings = ["https:", "http:", "mailto:", "tel:"];
  const checkMatch = url.match(regex);
  if (!checkMatch) return sanitizedUrl;
  if (checkMatch.some((item) => !allowedStrings.includes(item))) return "#";
  return sanitizedUrl;
};
MethodService.trimSpace = (str) => {
  if (typeof str !== "string") return str;
  return str.replace(/\s+/g, " ").trim();
};
MethodService.copyObject = function (value) {
  return JSON.parse(JSON.stringify(value));
};
// bấm sắp xếp bảng
MethodService.tableSortChange = (column, tableRules) => {
  if (column.order === "ascending") {
    tableRules.sort = column.prop;
  } else if (column.order === "descending") {
    tableRules.sort = "-" + column.prop;
  } else tableRules.sort = "";

  return tableRules.sort;
};

// tìm kiếm bảng
MethodService.filterTable = function (jsonFilter) {
  if (jsonFilter) {
    let dataSearch = JSON.parse(jsonFilter);
    let filters = "";
    for (const key in dataSearch.value) {
      const value = dataSearch.value[key];
      if (value) {
        if (dataSearch.operator) {
          if (dataSearch.operator[key]) {
            let operator = dataSearch.operator[key];
            if (operator == "<+1day") {
              filters +=
                key +
                "<" +
                encodeURIComponent(
                  encodeURIComponent(MethodService.addDate(value, "days", 1)),
                ) +
                "&";
            } else if (operator == "$vn_text=") {
              filters += operator + encodeURIComponent(value) + "&";
            } else if (operator == ":in_that_day:") {
              filters +=
                key +
                ">=" +
                encodeURIComponent(MethodService.toIsoDate(value)) +
                "&" +
                key +
                "<" +
                encodeURIComponent(
                  MethodService.toIsoDate(
                    MethodService.addDate(value, "days", 1),
                  ),
                ) +
                "&";
            } else if (operator.match(/^:regex(_\w+)?:$/)) {
              filters +=
                key + operator + encodeURIComponent(escapeRegex(value)) + "&";
            } else if (operator == ":in:") {
              filters += key + operator + encodeURIComponent(value) + "&";
            } else if (operator == "fromTime") {
              filters +=
                key +
                ">=" +
                encodeURIComponent(MethodService.toIsoDate(value)) +
                "&";
            } else if (operator == "toTime") {
              filters +=
                key +
                "<=" +
                encodeURIComponent(MethodService.toIsoDate(value)) +
                "&";
            } else if (operator == ":timeRange:") {
              let startDate = MethodService.toIsoDate(value[0]);
              let endDate = MethodService.toIsoDate(value[1]);
              filters +=
                Filter.and(
                  Filter.gte(key, startDate),
                  Filter.lte(key, endDate),
                ) + "&";
            } else {
              filters += key + operator + encodeURIComponent(value) + "&";
            }
          } else {
            filters += key + "=" + encodeURIComponent(value) + "&";
          }
        } else {
          filters += key + "=" + encodeURIComponent(value) + "&";
        }
      }
    }

    return filters.slice(0, -1);
  } else {
    return "";
  }
};

MethodService.unescapeRegex = (string) =>
  string.toString().replace(/\\([-/\\^$*+?.()|[\]{}])/g, "$1");
MethodService.stringToObject = (value) => {
  const obj = {};
  if (!value) return obj;
  value.split("&").forEach((item) => {
    const m = decodeURIComponent(item).match(
      /^(\w+(\.\w+)*)(=|>=|<=|<|>|<>|!=|:\w+:)(.*)/,
    );
    if (!m) return;
    if (m[1] in obj) {
      let arr = Array.isArray(obj[m[1]]) ? obj[m[1]] : [obj[m[1]]];
      arr.push(m[4]);
      obj[m[1]] = arr;
      return;
    }
    if (m[3].match(/:regex(_\w+)?:/))
      obj[m[1]] = MethodService.unescapeRegex(m[4]);
    if (m[3] === ":elemMatch:") {
      const arrKeyValue = m[4].split(",");
      arrKeyValue.forEach((keyValue) => {
        const keyValuePair = keyValue.split(/=|>=|<=|<|>|<>|!=|:\w+:/);
        obj[`${m[1]}.${keyValuePair[0]}`] = keyValuePair[1];
      });
    } else obj[m[1]] = m[4];
  });
  return obj;
};

// lưu tìm kiếm, sắp xếp khi reload trang web
MethodService.hashUrl = (routeQuery, tableRules) => {
  if (routeQuery.limit) {
    tableRules.limit = parseInt(routeQuery.limit);
  }
  if (routeQuery.offset) {
    tableRules.offset = parseInt(routeQuery.offset);
  }
  if (routeQuery.offset && routeQuery.limit) {
    tableRules.page = parseInt(routeQuery.offset / routeQuery.limit) + 1;
  }
  if (routeQuery.page) {
    tableRules.page = parseInt(routeQuery.page);
  }
  if (routeQuery.offset) {
    tableRules.offset = parseInt(routeQuery.offset);
  }
  if (routeQuery.limit && routeQuery.page) {
    tableRules.offset = (tableRules.page - 1) * tableRules.limit;
  }
  if (routeQuery.sort) {
    tableRules.sort = routeQuery.sort;
    tableRules.defaultSort[0] = tableRules.sort;
    tableRules.defaultSort[1] =
      tableRules.sort.indexOf("-") != -1 ? "descending" : "ascending";
  }
  if (routeQuery.filters) {
    tableRules.filters = routeQuery.filters;
    // string to object
    tableRules.dataSearch.value = MethodService.stringToObject(
      tableRules.filters,
    );
  }
  tableRules.showFormSearch =
    routeQuery.showFormSearch == "true" ? true : false;
};
MethodService.routerReplace = (nameRouter, tableRules) => {
  let objRouter = {};
  objRouter.name = nameRouter;
  objRouter.query = {
    limit: tableRules.limit,
    offset: tableRules.offset,
    sort: tableRules.sort,
    filters: tableRules.filters,
    showFormSearch: tableRules.showFormSearch,
  };
  return objRouter;
};
// show lỗi
MethodService.showError = (maCode) => {
  switch (maCode) {
    case 4:
      window.toastr.error(
        LanguageService?.lang?.toastr_internet_connection_error ??
          "toastr_internet_connection_error",
      );
      break;
    case 2:
      window.toastr.error(
        LanguageService?.lang?.toastr_lost_connection_to_server_error ??
          "toastr_lost_connection_to_server_error",
      );
      break;
    default:
      window.toastr.error(
        LanguageService?.lang?.toastr_error ?? "toastr_error",
      );
  }
};

// Xử lý lỗi chính sách mật khẩu mạnh (code 37002)
MethodService.handlePasswordPolicyError = (error, t) => {
  if (error?.code !== 37002) return false;
  const subCode = error?.meta?.subCode ?? error?.subCode;
  switch (subCode) {
    case 1:
      window.toastr.warning(
        t
          ? t("t_password_policy_min_length", {
              minLength: error.meta.minLength,
            })
          : LanguageService?.lang?.t_password_policy_min_length?.replace(
              "{minLength}",
              error.meta.minLength,
            ) ?? "t_password_policy_min_length",
      );
      return true;
    case 2:
      window.toastr.warning(
        t
          ? t("t_password_policy_complexity")
          : LanguageService?.lang?.t_password_policy_complexity ??
              "t_password_policy_complexity",
      );
      return true;
    case 3:
      window.toastr.warning(
        t
          ? t("t_password_policy_history", { times: error.meta.times })
          : LanguageService?.lang?.t_password_policy_history?.replace(
              "{times}",
              error.meta.times,
            ) ?? "t_password_policy_history",
      );
      return true;
    default:
      return false;
  }
};

function toRad(Value) {
  /** Converts numeric degrees to radians */
  return (Value * Math.PI) / 180;
}

MethodService.distFrom = (lat1, lon1, lat2, lon2) => {
  //Radius of the earth in:  1.609344 miles,  6371 km  | var R = (6371 / 1.609344);
  const R = 3958.7558657440545; // Radius of earth in Miles
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c;
  return d;
};

MethodService.getTokenAccount = (token) => {
  return "access_token=" + encodeURIComponent(token);
};

MethodService.exportExcel = function (cols, dataList, cardTitle, sheetName) {
  let workbook = new Excel.Workbook();

  workbook.created = new Date();
  workbook.calcProperties.fullCalcOnLoad = false;
  workbook.views = [
    {
      x: 0,
      y: 0,
      width: 10000,
      height: 20000,
      firstSheet: 0,
      activeTab: 0,
      visibility: "visible",
    },
  ];

  let worksheet = workbook.addWorksheet(sheetName, {
    views: [{ state: "frozen", xSplit: 1, ySplit: 1 }],
  });

  let arr = [];
  cols.forEach((item) => {
    let obj = {};
    obj.header = item.title;
    obj.key = item.title;
    obj.width = 30;
    arr.push(obj);
  });

  worksheet.columns = [...arr];

  let row = worksheet.getRow(1);
  row.eachCell(function (cell, colNumber) {
    row.getCell(colNumber).font = { bold: true };
    row.getCell(colNumber).alignment = {
      vertical: "middle",
      horizontal: "center",
    };
  });

  dataList.forEach((items) => {
    worksheet.addRow(items);
  });

  worksheet.getRow(1).height = 20;
  worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
    row.eachCell(function (cell, colNumber) {
      console.log("colNumber", colNumber);
      if (rowNumber == 1) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "151529" },
        };
        cell.font = {
          color: { argb: "FFFFFF" },
          bold: true,
        };
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true,
        };
      } else {
        cell.alignment = {
          vertical: "middle",
          wrapText: true,
        };
      }
      // Set border of each cell
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
  });

  workbook.xlsx.writeBuffer().then(function (data) {
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    FileSaver.saveAs(blob, cardTitle + ".xlsx");
  });
};

// format date
let formatDateMonth = "MM/YYYY";
let formatDateMoment = "DD/MM/YYYY";
let formatMomentDate = "YYYY-MM-DD";
MethodService.formatDate = function (value) {
  if (!value) {
    return "";
  }
  if (moment(value).millisecond() === 0) {
    return moment(value).add().format("YYYY-MM-DD HH:mm:ss");
  } else return moment(value).add().format("YYYY-MM-DD HH:mm:ss.SSS");
};

MethodService.formatDateDDMM = function (value) {
  if (!value) return "";
  return moment(value).format("D-MM");
};
MethodService.formatDateStyle = function (value, rule) {
  if (value) {
    let format = "";
    if (rule == "date") {
      format = formatDateMoment;
    } else if (rule == "datetime") {
      format = formatDateMoment + " HH:mm";
    } else if (rule == "aboutTime") {
      format = formatDateMoment + " HH:mm";
    } else if (rule == "datetimeWithSecond") {
      format = formatDateMoment + " HH:mm:ss";
    } else if (rule == "month") {
      format = formatDateMonth;
    } else if (rule == "year") {
      format = formatMomentDate;
    } else {
      format = rule;
    }
    return moment(value).format(format);
  } else {
    return "";
  }
};
MethodService.downloadFileDashboard = async (id, filename) => {
  const data = { id };
  const headers = {
    "Content-Type": "application/json",
    "X-HTTP-Method-Override": "downloadFile",
    Token: window.localStorage.getItem(
      "mushroom.tokens" + "[" + mushroom.$using() + "]",
    ),
  };
  const response = await fetch(
    mushroom.$using() + "request_download_dashboards/downloadFile",
    {
      method: "POST",
      headers: headers,
      body: JSON.stringify(data),
    },
  );

  const blob = await response.blob();
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = response.headers.get("filename") || filename;
  console.log(
    "response.headers.get(FileName)",
    response.headers,
    link.download,
  );

  link.click();
};

MethodService.encodeHtml = function (template = "") {
  if (template === undefined || template === null) return "";
  let html = typeof template === "string" ? template : template.toString();
  html = html.replace(/&/g, "&amp;");
  html = html.replace(/</g, "&lt;");
  html = html.replace(/>/g, "&gt;");
  html = html.replace(/"/g, "&quot;");
  html = html.replace(/'/g, "&apos;");
  return html;
};

MethodService.thumbIcon = (idImage, height) => {
  return mushroom.$file.linkBuilder.thumb
    .id(idImage)
    .clip(height, height, "middle", "center")
    .build();
};

MethodService.isIconId = (icon) => {
  return !!icon && /^[a-f0-9]{24}$/i.test(icon);
};

MethodService.toIsoDate = (date) => {
  if (date === null || date === undefined) return "";
  return date instanceof Date
    ? date.toISOString()
    : new Date(date).toISOString();
};

MethodService.addDate = (value, type, numberTime) => {
  if (!value) return "";
  return moment(value).add(numberTime, type).format("YYYY-MM-DDTHH:mm:ss");
};

MethodService.getSecureRandomInt = (min, max) => {
  if (min > max) {
    throw new Error("Min must not be greater than Max");
  }
  const range = max - min + 1;
  if (range <= 0 || range > Number.MAX_SAFE_INTEGER) {
    throw new Error("Range must be a positive safe integer");
  }

  // Calculate the maximum value that fits evenly into 256
  const maxValidValue = Math.floor((Math.pow(2, 32) - 1) / range) * range;

  let randomValue;
  do {
    const array = new Uint32Array(1);
    window.crypto.getRandomValues(array); // Generate a secure random value
    randomValue = array[0];
  } while (randomValue > maxValidValue);

  return min + (randomValue % range);
};
// ── Validate IPv4
MethodService.isValidIPv4CIDR = function (value) {
  const ipv4CidrRegex = /^(\d{1,3}\.){3}\d{1,3}\/(\d|[12]\d|3[0-2])$/;
  if (!ipv4CidrRegex.test(value)) return false;

  const [ip] = value.split("/");
  return ip.split(".").every((octet) => Number(octet) <= 255);
};

// ── Validate IPv6
function isValidIPv6Address(ip) {
  if (!/^[\da-fA-F:]+$/.test(ip)) return false;
  if ((ip.match(/::/g) || []).length > 1) return false;
  if (ip.includes(":::")) return false;
  if (/^:[^:]|[^:]:$/.test(ip)) return false;

  if (ip.includes("::")) {
    const sides = ip.split("::");
    const left = sides[0] ? sides[0].split(":") : [];
    const right = sides[1] ? sides[1].split(":") : [];
    if (left.length + right.length > 7) return false;
    return [...left, ...right].every((g) => /^[\da-fA-F]{1,4}$/.test(g));
  }

  const groups = ip.split(":");
  if (groups.length !== 8) return false;
  return groups.every((g) => /^[\da-fA-F]{1,4}$/.test(g));
}

MethodService.isValidIPv6CIDR = function (value) {
  const ipv6CidrRegex = /^[\da-fA-F:]+\/(\d|[1-9]\d|1[01]\d|12[0-8])$/;
  if (!ipv6CidrRegex.test(value)) return false;

  const [ip] = value.split("/");
  return isValidIPv6Address(ip);
};

MethodService.checkNeedToChangePassword = async ({ router, t }) => {
  try {
    const response = await mushroom.user.need_to_change_passwordAsync({});
    const level = response.result?.level;
    const lastChangeTime = response.result?.lastChangeTime;
    const mustChangeAfterMinutes = response.result?.mustChangeAfterMinutes;

    // Tính thời điểm hết hạn mật khẩu
    let expiredTime = "";
    if (lastChangeTime && mustChangeAfterMinutes) {
      const expiredDate = new Date(
        new Date(lastChangeTime).getTime() + mustChangeAfterMinutes * 60 * 1000,
      );
      const dd = String(expiredDate.getDate()).padStart(2, "0");
      const MM = String(expiredDate.getMonth() + 1).padStart(2, "0");
      const yyyy = expiredDate.getFullYear();
      const HH = String(expiredDate.getHours()).padStart(2, "0");
      const mm = String(expiredDate.getMinutes()).padStart(2, "0");
      expiredTime = `${dd}-${MM}-${yyyy} ${HH}:${mm}`;
    }

    if (level === "must") {
      router.push({
        path: "/reset-password",
        query: { level, expiredTime },
      });
      return true;
    } else if (level === "should") {
      const warningText = expiredTime
        ? t("t_password_change_warning_should", { time: expiredTime })
        : t("t_password_change_warning");
      Swal.fire({
        title: t("t_warning"),
        text: warningText,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: t("t_password_change_go"),
        cancelButtonText: t("t_password_change_later"),
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          router.push({
            path: "/reset-password",
            query: { level, expiredTime },
          });
        }
      });
      return false;
    }
    return false;
  } catch (e) {
    return false;
  }
};

// Kiểm tra giá trị có phải số hay không (loại bỏ null, undefined, chuỗi rỗng)
MethodService.isNumericValue = (val) => {
  if (val === null || val === undefined || val === "") return false;
  return !isNaN(Number(val));
};

export default MethodService;
